import * as types from '../actions/types';

const initState = {
    list: [],
    loading: false,
    loadingError: null,

    sendingInput: false,
    sendingInputError: null
};

export default function BonusTasksReducer (state = initState, action) {

    switch (action.type)
    {
        case types.BONUS_TASKS_LIST:
            return {...state, list: [], loading: true, loadingError: null };

        case types.BONUS_TASKS_LIST_SUCCESS:
            return {...state, list: action.payload.list, loading: false, loadingError: null };

        case types.BONUS_TASKS_LIST_ERROR:
            return {...state, list: [], loading: false, loadingError: action.payload };

        case types.BONUS_TASKS_SUBMIT_SUCCESS:
            let submittedTaskId = action.meta.id;
            let newList = state.list.map((task) => { return task.id === submittedTaskId ? action.payload : task });
            return {...state, list: newList};

        default:
            return state;
    }

}
